export default {
  label: '首席技术官（CTO）',
  id: '0',
  children: [
    {
      label: '定义',
      id: '0-1',
      children: [
        {
          label: '公司技术战略的制定者。',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '职责',
      id: '0-2',
      children: [
        {
          label: '制定公司技术战略，建立技术架构，管理研发流程，支撑业务发展。',
          id: '0-2-1',
        },
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '具备全面的技术背景和管理能力，能够影响公司战略方向。',
          id: '0-3-1',
        },
      ],
    },
    {
      label: '职业发展',
      id: '0-4',
      children: [
        {
          label: '通常在20年以上经验后成为公司高层领导。',
          id: '0-4-1',
        },
      ],
    },
    {
      label: '薪资水平',
      id: '0-5',
      children: [
        {
          label: '年薪通常在100-200万元。',
          id: '0-5-1',
        },
      ],
    },
  ],
};